import React, { useEffect, useRef, useMemo, useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CameraswitchOutlinedIcon from "@mui/icons-material/CameraswitchOutlined";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import LinkIcon from "@mui/icons-material/Link";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import BlockIcon from "@mui/icons-material/Block";
import StraightenIcon from "@mui/icons-material/Straighten";
import UndoIcon from "@mui/icons-material/Undo";
import SaveIcon from "@mui/icons-material/Save";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import OpenWithOutlinedIcon from "@mui/icons-material/OpenWithOutlined";

import {
  Alert,
  Box,
  Button,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
} from "@mui/material";
import Fusion3DModel from "./components/Fusion3DModel.jsx";
import Fusion2DModel from "./components/Fusion2DModel.jsx";
import Fusion360Images from "./components/Fusion360Images.jsx";
import LoadingAnimation from "./components/LoadingAnimation.jsx";
import ExportModal from "./components/ExportModal.jsx";
import AIAssistantPanel from "./components/AIAssistantPanel.jsx";
import AnnotationPanel from "./components/AnnotationPanel.jsx";
import {
  get3DModelURL,
  get2DModelURL,
  get360ModelURL,
} from "../../actions/3dFusionAction";
import { GET_2D_MODEL_URL, GET_3D_MODEL_URL } from "../../actions/types";
import { useDispatch, useSelector } from "react-redux";

const Fusion = () => {
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [sections, setSections] = useState({
    scanInfo: true,
    synchronize: false,
    export: false,
    previousScan: false,
    settings: false,
    generateLink: false,
  });
  const dispatch = useDispatch();
  const threeDFusion = useSelector((state) => state.threeDFusion);
  const model3DUrl = threeDFusion["3DModel"]?.modelUrl;
  const model2DUrl = threeDFusion["2DModel"]?.modelUrl;
  const model360Url = threeDFusion["360View"]?.modelUrl;
  const scanInfo = threeDFusion.scanInfo?.data || [];
  const scanInfoLoading = threeDFusion.scanInfo?.loading;
  const floor = useSelector((state) => state.floor);

  const [tool, setTool] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [zoom2D, setZoom2D] = useState(1);
  const [selected2DPreviousScan, setSelected2DPreviousScan] = useState(null);
  const [selected3DPreviousScan, setSelected3DPreviousScan] = useState(null);
  const [selected2DTool, setSelected2DTool] = useState("");
  const [selected3DTool, setSelected3DTool] = useState("");
  const [selectedAITool, setSelectedAITool] = useState("");
  const [annotationMode, setAnnotationMode] = useState(null);
  const [annotationText, setAnnotationText] = useState("");
  const [aiMode, setAiMode] = useState(false);
  const [aiInput, setAiInput] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [viewerWarning, setViewerWarning] = useState("");
  const [annotations, setAnnotations] = useState({
    type: "FeatureCollection",
    features: [],
  });

  const isEditableShortcutTarget = (target) => {
    if (!target || !(target instanceof HTMLElement)) {
      return false;
    }

    const tagName = target.tagName?.toLowerCase();

    return (
      target.isContentEditable ||
      tagName === "input" ||
      tagName === "textarea" ||
      tagName === "select"
    );
  };

  const formatScanLabel = (scan, index) => {
    const rawDate = scan?.capture_time || scan?.created_at;
    console.log("test rawDate", rawDate);

    if (!rawDate) {
      return `Scan ${index + 1}`;
    }

    const parsedDate = new Date(rawDate);

    if (Number.isNaN(parsedDate.getTime())) {
      return rawDate;
    }

    return parsedDate.toLocaleDateString(undefined, {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const addAnnotation = ({ lng, lat }) => {
    const newAnnotation = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [lng, lat],
      },
      properties: {
        text: annotationText,
        timestamp: new Date().toISOString(),
      },
    };

    setAnnotations((prev) => ({
      ...prev,
      features: [...prev.features, newAnnotation],
    }));

    // Reset annotation state
    setAnnotationText("");
    setAnnotationMode(null);
  };

  const deleteAnnotation = (index) => {
    setAnnotations((prev) => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index),
    }));
  };

  const toggleDrawer = (isOpen) => (event) => {
    if (
      isOpen === false &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(isOpen);
  };

  const toggleSection = (key) => () => {
    setSections((prev) => {
      const updatedSections = { ...prev, [key]: !prev[key] };
      // Auto-select first item when opening previousScan
      if (
        key === "previousScan" &&
        updatedSections.previousScan &&
        selected2DPreviousScan === null && tool ==="2D" &&
        scan_history_2D.length > 0
      ) {
        setSelected2DPreviousScan(0);
      }
    
      if(
        key === "previousScan" && updatedSections.previousScan &&
        selected3DPreviousScan === null && tool === "3D" &&
        scan_history_3D.length > 0
      ){
        setSelected3DPreviousScan(0);
      }

      return updatedSections;
    });
  };

  const handleChangeTool = (e, newTool) => {
    if (newTool && newTool !== tool) {
      setIsLoading(true);
      setTool(newTool);

      // Simulate loading time for tool switch
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }

    if (newTool === "2D") {
      setSelected2DTool("panzoom");
    }
  };

  const scan_history_360 = useMemo(() => {
    return scanInfo.filter((scan) => scan.file_format === "obj");
  }, [scanInfo]);

  const scan_history_2D = useMemo(() => {
    return scanInfo.filter((scan) => scan.file_format === "pgm");
  }, [scanInfo]);

  const scan_history_3D = useMemo(() => {
    return scanInfo.filter((scan) => scan.file_format === "laz");
  }, [scanInfo]);

  const active2DScanIndex =
    selected2DPreviousScan !== null &&
    selected2DPreviousScan >= 0 &&
    selected2DPreviousScan < scan_history_2D.length
      ? selected2DPreviousScan
      : 0;

  const active3DScanIndex =
    selected3DPreviousScan !== null &&
    selected3DPreviousScan >= 0 &&
    selected3DPreviousScan < scan_history_3D.length
      ? selected3DPreviousScan
      : 0;

  const active2DScan = scan_history_2D[active2DScanIndex] || null;
  const active3DScan = scan_history_3D[active3DScanIndex] || null;

  useEffect(() => {
    const nextDefaultTool = scan_history_360.length > 0
      ? "360Images"
      : scan_history_2D.length > 0
        ? "2D"
        : scan_history_3D.length > 0
          ? "3D"
          : null;

    if (!nextDefaultTool) {
      setTool(null);
      return;
    }

    setTool((currentTool) => {
      if (currentTool === "360Images" && scan_history_360.length > 0) {
        return currentTool;
      }

      if (currentTool === "2D" && scan_history_2D.length > 0) {
        return currentTool;
      }

      if (currentTool === "3D" && scan_history_3D.length > 0) {
        return currentTool;
      }

      return nextDefaultTool;
    });
  }, [scan_history_360, scan_history_2D, scan_history_3D]);

  useEffect(() => {
    if (scan_history_2D.length === 0) {
      setSelected2DPreviousScan(null);
      return;
    }

    setSelected2DPreviousScan((currentIndex) => {
      if (
        currentIndex !== null &&
        currentIndex >= 0 &&
        currentIndex < scan_history_2D.length
      ) {
        return currentIndex;
      }

      return 0;
    });
  }, [scan_history_2D]);

  useEffect(() => {
    if (scan_history_3D.length === 0) {
      setSelected3DPreviousScan(null);
      return;
    }

    setSelected3DPreviousScan((currentIndex) => {
      if (
        currentIndex !== null &&
        currentIndex >= 0 &&
        currentIndex < scan_history_3D.length
      ) {
        return currentIndex;
      }

      return 0;
    });
  }, [scan_history_3D]);

  useEffect(() => {
    if (!tool) {
      return;
    }

    setViewerWarning("");
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [tool]);

  useEffect(() => {
    if (tool !== "2D") {
      return;
    }

    setSelected2DTool((currentTool) => currentTool || "panzoom");
  }, [tool]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (tool !== "2D" || scan_history_2D.length === 0) {
        return;
      }

      if (
        event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        isEditableShortcutTarget(event.target)
      ) {
        return;
      }

      const shortcutMap = {
        z: "panzoom",
        x: "hand",
        c: "draw",
      };

      const nextTool = shortcutMap[event.key.toLowerCase()];

      if (!nextTool) {
        return;
      }

      event.preventDefault();
      setSelected2DTool(nextTool);
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [scan_history_2D.length, tool]);

  useEffect(() => {
    setViewerWarning("");

    if (tool !== "2D") {
      dispatch({
        type: GET_2D_MODEL_URL,
        payload: {
          "2DModel": {
            loading: false,
            modelUrl: null,
            contentType: null,
          },
        },
      });
    }

    if (tool !== "3D") {
      dispatch({
        type: GET_3D_MODEL_URL,
        payload: {
          "3DModel": {
            loading: false,
            modelUrl: null,
            contentType: null,
          },
        },
      });
    }
  }, [tool, dispatch]);

  useEffect(() => {
    if (!floor?.id) {
      return;
    }

    setViewerWarning("");
    setSelected2DPreviousScan(null);
    setSelected3DPreviousScan(null);

    dispatch({
      type: GET_2D_MODEL_URL,
      payload: {
        "2DModel": {
          loading: false,
          modelUrl: null,
          contentType: null,
        },
      },
    });

    dispatch({
      type: GET_3D_MODEL_URL,
      payload: {
        "3DModel": {
          loading: false,
          modelUrl: null,
          contentType: null,
        },
      },
    });
  }, [floor?.id, dispatch]);

  useEffect(() => {
    if (tool !== "3D" || scan_history_3D.length === 0) {
      return;
    }

    if (!threeDFusion["3DModel"]?.loading && !model3DUrl) {
      setViewerWarning("Unable to load 3D scan file. Please contact administrator for support.");
    }
  }, [tool, scan_history_3D.length, model3DUrl, threeDFusion]);

  useEffect(() => {
    if (
      tool === "2D" &&
      !threeDFusion["2DModel"]?.loading &&
      Boolean(model2DUrl)
    ) {
      setViewerWarning("");
      return;
    }

    if (
      tool === "3D" &&
      !threeDFusion["3DModel"]?.loading &&
      Boolean(model3DUrl)
    ) {
      setViewerWarning("");
    }
  }, [tool, model2DUrl, model3DUrl, threeDFusion]);

  useEffect(() => {
    if (scanInfo.length === 0 || !tool) {
      return;
    }

    if (tool === "360Images" && scan_history_360.length > 0) {
      dispatch(
        get360ModelURL({
          fileURL: scan_history_360[0]?.file_url,
          modelType: "360View",
        }),
      );
      return;
    }

    if (tool === "2D" && scan_history_2D.length > 0) {
      dispatch(
        get2DModelURL({
          containerName: "virbrixmodels",
          fileName: active2DScan?.file_url,
          modelType: "2DModel",
        }),
      );
      return;
    }

    if (tool === "3D" && scan_history_3D.length > 0) {
      dispatch(
        get3DModelURL({
          containerName: "virbrixmodels",
          fileName: active3DScan?.file_url,
          modelType: "3DModel",
        }),
      );
    }
  }, [
    dispatch,
    scanInfo,
    tool,
    scan_history_360,
    scan_history_2D,
    scan_history_3D,
    active2DScan,
    active3DScan,
  ]);

  return (
    <>
      {/* Export Modal */}
      <ExportModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        currentTool={tool}
      />

      <div
        className="w-100 h-100 d-flex"
        style={{ position: "relative" }}
        ref={containerRef}
      >
        {/* Animation Screen */}
        <LoadingAnimation
          isLoading={isLoading}
          message={
            tool === "360Images"
              ? "Loading 360° view..."
              : tool === "2D"
                ? "Loading 2D map view..."
                : tool === "3D"
                  ? "Loading 3D model view..."
                  : "Loading..."
          }
        />

        {/* Sidebar Viewer Button */}
        <IconButton
          onClick={toggleDrawer(true)}
          aria-label="Open sidebar"
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            left: 20,
            zIndex: 10,
            bgcolor: "background.paper",
          }}
        >
          <ViewSidebarOutlinedIcon fontSize="small" sx={{ color: "#112138" }} />
        </IconButton>

        {/* Sidebar  */}
        <Drawer
          open={open}
          onClose={toggleDrawer(false)}
          anchor="left"
          variant="temporary"
          disablePortal
          ModalProps={{
            container: containerRef.current,
            keepMounted: true,
          }}
          sx={{
            position: "absolute",
            "& .MuiDrawer-paper": {
              width: 280,
              position: "absolute",
              height: "100%",
              boxSizing: "border-box",
            },
            "& .MuiDrawer-paper::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Box sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Explore your 3D Fusion
            </Typography>
          </Box>
          <Divider />
          <List dense disablePadding>
            {/* Scan Info */}
            <ListItemButton onClick={toggleSection("scanInfo")}>
              <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                <InfoOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Scan Info"
                primaryTypographyProps={{ fontSize: "0.95rem" }}
              />
              {/* {sections.scanInfo ? <ExpandLess /> : <ExpandMore />} */}
            </ListItemButton>
            {/* <Collapse in={sections.scanInfo} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary="View Mode" />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary="Quality" />
                </ListItemButton>
              </List>
            </Collapse> */}

            {/* Synchronize */}
            <ListItemButton onClick={toggleSection("synchronize")}>
              <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                <SyncOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Synchronize"
                primaryTypographyProps={{ fontSize: "0.95rem" }}
              />
              {/* {sections.synchronize ? <ExpandLess /> : <ExpandMore />} */}
            </ListItemButton>

            {/* Export */}
            <ListItemButton onClick={() => setExportModalOpen(true)}>
              <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                <FileDownloadOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Export"
                primaryTypographyProps={{ fontSize: "0.95rem" }}
              />
              {/* {sections.export ? <ExpandLess /> : <ExpandMore />} */}
            </ListItemButton>

            {/* Generate Integration Link */}
            <ListItemButton onClick={toggleSection("generateLink")}>
              <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                <LinkIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Sync to Autodesk Platform Services"
                primaryTypographyProps={{ fontSize: "0.95rem" }}
              />
            </ListItemButton>

            {/* Previous Scan */}
            {tool !== "360Images" && (
              <ListItemButton onClick={toggleSection("previousScan")}>
                <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                  <HistoryOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Previous Scan"
                  primaryTypographyProps={{ fontSize: "0.95rem" }}
                />
                {sections.previousScan ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            )}

            <Collapse in={sections.previousScan} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {scanInfoLoading ? (
                  <ListItemButton sx={{ pl: 4 }} disabled>
                    <ListItemText
                      primary="Loading scans..."
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                ) : scanInfo.length === 0 ? (
                  <ListItemButton sx={{ pl: 4 }} disabled>
                    <ListItemText
                      primary="No scans available"
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                ) : tool === '2D' && scan_history_2D?.length > 0 ? 
                (
                  scan_history_2D?.map((scan, index) => (
                    <ListItemButton
                      sx={{
                        pl: 4,
                        backgroundColor:
                          selected2DPreviousScan === index
                            ? "rgba(0, 0, 0, 0.08)"
                            : "transparent",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.12)",
                        },
                      }}
                      onClick={() => {
                        setViewerWarning("");
                        setSelected2DPreviousScan(index);
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                        <EventOutlinedIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={formatScanLabel(scan, index)}
                        secondary={
                          scan.file_format
                            ? `${scan.file_format.toUpperCase()}${scan.version ? ` • v${scan.version}` : ""} ${scan.job_id ? ` • ${scan.job_id}` : ""}`
                            : scan.processing_status || undefined
                        }
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                        secondaryTypographyProps={{ fontSize: "0.72rem" }}
                      />
                    </ListItemButton>
                  ))
                ):tool === '3D' && scan_history_3D?.length > 0 ? (
                 scan_history_3D?.map((scan, index) => (
                    <ListItemButton
                      key={scan.id || index}
                      sx={{
                        pl: 4,
                        backgroundColor:
                          selected3DPreviousScan === index
                            ? "rgba(0, 0, 0, 0.08)"
                            : "transparent",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.12)",
                        },
                      }}
                      onClick={() => {
                        setViewerWarning("");
                        setSelected3DPreviousScan(index);
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                        <EventOutlinedIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={formatScanLabel(scan, index)}
                        secondary={
                          scan.file_format
                            ? `${scan.file_format.toUpperCase()}${scan.version ? ` • v${scan.version}` : ""} ${scan.job_id ? ` • ${scan.job_id}` : ""}`
                            : scan.processing_status || undefined
                        }
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                        secondaryTypographyProps={{ fontSize: "0.72rem" }}
                      />
                    </ListItemButton>
                  ))
                ):null}
              </List>
            </Collapse>

            {/* Settings */}
            <ListItemButton onClick={toggleSection("settings")}>
              <ListItemIcon sx={{ minWidth: 32, color: "#112138" }}>
                <SettingsOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Settings"
                primaryTypographyProps={{ fontSize: "0.95rem" }}
              />
              {/* {sections.settings ? <ExpandLess /> : <ExpandMore />} */}
            </ListItemButton>
          </List>
          <Divider />
        </Drawer>

        {/* Display View */}
        <div className="relative flex-grow-1">
          {/* Toolbar */}
          <div>
            {/* Model Viewer Navigation Toggle + Toolset */}
            <div
              style={{
                position: "absolute",
                top: 50,
                left: 20,
                zIndex: 100,
                display: "flex",
                flexDirection: "column",
                gap: 8,
                alignItems: "flex-start",
              }}
            >
              <ToggleButtonGroup
                orientation="vertical"
                value={tool}
                exclusive
                sx={{
                  bgcolor: "background.paper",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: 1,
                  "& .MuiToggleButton-root": {
                    border: "none",
                    borderRadius: 0,
                    px: 1.5,
                    py: 1.25,
                    color: "#000",
                  },
                  "& .MuiToggleButton-root.Mui-selected": {
                    color: "#fff",
                    bgcolor: "#112138",
                  },
                  "& .MuiToggleButton-root.Mui-selected:hover": {
                    bgcolor: "#112138",
                  },
                }}
                onChange={handleChangeTool}
              >
                {/* 360 Images Button */}
                {scan_history_360.length > 0 && (
                  <ToggleButton value="360Images" aria-label="360Images">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.25,
                      }}
                    >
                      <CameraswitchOutlinedIcon fontSize="small" />
                      <Typography variant="caption">360</Typography>
                    </Box>
                  </ToggleButton>
                )}

                {/* 2D Button */}
                {scan_history_2D.length > 0 && (
                  <ToggleButton value="2D" aria-label="2D">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.25,
                      }}
                    >
                      <LayersOutlinedIcon fontSize="small" />
                      <Typography variant="caption">2D</Typography>
                    </Box>
                  </ToggleButton>
                )}

                {/* 3D Button */}
                {scan_history_3D.length > 0 && (
                  <ToggleButton value="3D" aria-label="3D">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.25,
                      }}
                    >
                      <ViewInArOutlinedIcon fontSize="small" />
                      <Typography variant="caption">3D</Typography>
                    </Box>
                  </ToggleButton>
                )}
              </ToggleButtonGroup>

              {/* 2D Toolset */}
              {tool === "2D" && scan_history_2D.length > 0 && (
                <ToggleButtonGroup
                  orientation="vertical"
                  exclusive
                  value={selected2DTool}
                  onChange={(e, newTool) => {
                    if (newTool) {
                      setSelected2DTool(newTool);
                    }
                  }}
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: 1,
                    "& .MuiToggleButton-root": {
                      border: "none",
                      borderRadius: 0,
                      px: 1.5,
                      py: 1.25,
                      color: "#000",
                    },
                    "& .MuiToggleButton-root.Mui-selected": {
                      color: "#fff",
                      bgcolor: "#112138",
                    },
                    "& .MuiToggleButton-root.Mui-selected:hover": {
                      bgcolor: "#112138",
                    },
                  }}
                >
                  <Tooltip title="Pan and zoom (Z)" arrow>
                    <ToggleButton value="panzoom" aria-label="panzoom">
                      <OpenWithOutlinedIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip>
                  <Tooltip title="Select room (X)" arrow>
                    <ToggleButton value="hand" aria-label="hand">
                      <PanToolOutlinedIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip>
                  <Tooltip title="Draw room (C)" arrow>
                    <ToggleButton value="draw" aria-label="draw">
                      <EditIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip>
                  {/* <Tooltip title="Clear all rooms" arrow>
                    <ToggleButton value="clear" aria-label="clear">
                      <ClearIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip> */}
                  {/* <Tooltip title="Wall detection" arrow>
                    <ToggleButton value="wall" aria-label="wall">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-bricks"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 .5A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2v-2H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 6H2V4H.5a.5.5 0 0 1-.5-.5zM3 4v2h4.5V4zm5.5 0v2H13V4zM3 10v2h4.5v-2zm5.5 0v2H13v-2zM1 1v2h3.5V1zm4.5 0v2h5V1zm6 0v2H15V1zM1 7v2h3.5V7zm4.5 0v2h5V7zm6 0v2H15V7zM1 13v2h3.5v-2zm4.5 0v2h5v-2zm6 0v2H15v-2z" />
                      </svg>
                    </ToggleButton>
                  </Tooltip> */}
                  <Tooltip title="Measure distance" arrow>
                    <ToggleButton value="measure" aria-label="measure">
                      <StraightenIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip>
                  {/* <Tooltip title="Undo last action" arrow>
                    <ToggleButton value="undo" aria-label="undo">
                      <UndoIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip> */}
                  {/* <Tooltip title="Save current room" arrow>
                    <ToggleButton value="save" aria-label="save">
                      <SaveIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip> */}
                </ToggleButtonGroup>
              )}

              {/* 3D Toolset */}
              {tool === "3D" && scan_history_3D.length > 0 && (
                <ToggleButtonGroup
                  orientation="vertical"
                  exclusive
                  value={selected3DTool}
                  onChange={(e, newTool) => {
                    setSelected3DTool(newTool);
                    setAnnotationMode(
                      newTool === "annotate" ? "annotate" : null,
                    );
                  }}
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: 1,
                    "& .MuiToggleButton-root": {
                      border: "none",
                      borderRadius: 0,
                      px: 1.5,
                      py: 1.25,
                      color: "#000",
                    },
                    "& .MuiToggleButton-root.Mui-selected": {
                      color: "#fff",
                      bgcolor: "#112138",
                    },
                    "& .MuiToggleButton-root.Mui-selected:hover": {
                      bgcolor: "#112138",
                    },
                  }}
                >
                  <Tooltip title="Add Annotation" arrow>
                    <ToggleButton value="annotate" aria-label="annotate">
                      <AddCommentOutlinedIcon fontSize="small" />
                    </ToggleButton>
                  </Tooltip>
                </ToggleButtonGroup>
              )}

              {/* AI & Integration Toolset */}

              <ToggleButtonGroup
                orientation="vertical"
                exclusive
                value={selectedAITool}
                onChange={(e, newTool) => {
                  setSelectedAITool(newTool);
                  setAiMode(newTool === "chatbot");
                }}
                sx={{
                  bgcolor: "background.paper",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: 1,
                  "& .MuiToggleButton-root": {
                    border: "none",
                    borderRadius: 0,
                    px: 1.5,
                    py: 1.25,
                    color: "#000",
                  },
                  "& .MuiToggleButton-root.Mui-selected": {
                    color: "#fff",
                    bgcolor: "#112138",
                  },
                  "& .MuiToggleButton-root.Mui-selected:hover": {
                    bgcolor: "#112138",
                  },
                }}
              >
                <Tooltip title="Virbrix AI Assistant" arrow>
                  <ToggleButton
                    value="chatbot"
                    aria-label="chatbot"
                    selected={aiMode}
                    onClick={() => setAiMode((prev) => !prev)}
                  >
                    <SmartToyOutlinedIcon fontSize="small" />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title="Workflow" arrow>
                  <ToggleButton value="workflow" aria-label="workflow">
                    <AutoAwesomeOutlinedIcon fontSize="small" />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>

            {/* Annotation Panel */}
            <AnnotationPanel
              annotationMode={annotationMode}
              setAnnotationMode={setAnnotationMode}
              annotationText={annotationText}
              setAnnotationText={setAnnotationText}
              tool={tool}
            />

            {/* AI Assistant Panel */}
            <AIAssistantPanel
              aiMode={aiMode}
              setAiMode={setAiMode}
              aiInput={aiInput}
              setAiInput={setAiInput}
              isRecording={isRecording}
              setIsRecording={setIsRecording}
              tool={tool}
            />
          </div>

          {/* View */}
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              overflow: "hidden",
              opacity: isLoading ? 0 : 1,
              visibility: isLoading ? "hidden" : "visible",
              transition: "opacity 0.3s ease-in-out",
            }}
          >
            {viewerWarning && (
              <Alert
                severity="warning"
                sx={{
                  position: "absolute",
                  top: 12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 1000,
                  maxWidth: 680,
                  width: "calc(100% - 48px)",
                }}
              >
                {viewerWarning}
              </Alert>
            )}

            {/* 360 Images View */}
            {tool === "360Images" && scan_history_360.length > 0 && (
              <Fusion360Images
                fileUrl={model360Url}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            )}

            {/* 2D View */}
            {tool === "2D" && scan_history_2D.length > 0 && model2DUrl && (
              <Fusion2DModel
                fileUrl={model2DUrl}
                scanFileUrl={active2DScan?.file_url || ""}
                scanJobId={active2DScan?.job_id || ""}
                selectedTool={selected2DTool}
                setSelected2DTool={setSelected2DTool}
                onError={(message) => {
                  if (message) {
                    setViewerWarning(message);
                  }
                }}
              />
            )}

            {/* 3D View */}
            {tool === "3D" && scan_history_3D.length > 0 && model3DUrl && (
              <>
                <Fusion3DModel
                  key={model3DUrl}
                  annotationMode={annotationMode}
                  annotationText={annotationText}
                  annotations={annotations}
                  onAddAnnotation={addAnnotation}
                  onDeleteAnnotation={deleteAnnotation}
                  fileUrl={model3DUrl}
                  center={[-79.3832, 43.6532]}
                  zoom={15}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Fusion;
